export const DAMAGE_IN_APP_EVIDENCE_FLAG = 'damage-in-app-evidence';
export const DAMAGE_VIDEO_BITRATE_FLAG = 'damage-video-bitrate';

export function getVideoBitsPerSecond(flag: string | boolean | undefined): number {
  if (flag === 'low') return 1_000_000;
  if (flag === 'high') return 6_000_000;
  return 2_500_000;
}

export function hasPendingDamageEvidence(damage: {
  expectedPhotoCount?: number;
  imageFileUrls?: string[];
  videoExpected?: boolean;
  videoFileUrl?: string | null;
}): boolean {
  const photosPending = (damage.expectedPhotoCount ?? 0) > (damage.imageFileUrls?.length ?? 0);
  const videoPending = !!damage.videoExpected && !damage.videoFileUrl;
  return photosPending || videoPending;
}

export function isTouchCaptureDevice(): boolean {
  if ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) return true;
  if (window.matchMedia?.('(pointer:coarse)').matches) return true;
  return 'orientation' in window;
}
